// In-portal notifications client.
//
// Backend: in.aumhum.aumhum.patient.controller.MeNotificationsController.
// All endpoints are scoped to the active patient profile via the
// patientId query param (the patientApi wrapper attaches it
// when requirePatientContext is true — the default for this module).

import { shouldUseMocks } from './mockApi'
import { patientGet, patientPost } from './patientApi'

const BASE = '/api/secure/me/notifications'

function unwrap(res) {
  return res?.data
}

/** GET /me/notifications?status=unread|all&page=&pageSize= — returns NotificationItem[]. */
export async function listNotifications({ status = 'all', page = 1, pageSize = 50 } = {}) {
  if (shouldUseMocks()) return []
  const res = await patientGet(BASE, {
    requirePatientContext: true,
    params: { status, page, pageSize },
  })
  return unwrap(res) || []
}

/** GET /me/notifications/unread-count — returns { count: number }. */
export async function getUnreadCount() {
  if (shouldUseMocks()) return { count: 0 }
  const res = await patientGet(`${BASE}/unread-count`, { requirePatientContext: true })
  return unwrap(res) || { count: 0 }
}

/** POST /me/notifications/:id/read — marks one notification read. */
export async function markRead(notificationId) {
  if (shouldUseMocks()) return null
  const res = await patientPost(
    `${BASE}/${encodeURIComponent(notificationId)}/read`,
    null,
    { requirePatientContext: true },
  )
  return unwrap(res)
}

/** POST /me/notifications/read-all — marks every unread notification read. */
export async function markAllRead() {
  if (shouldUseMocks()) return null
  const res = await patientPost(`${BASE}/read-all`, null, { requirePatientContext: true })
  return unwrap(res)
}
